module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAANJJREFUSA1j1DTr+M8ABFemN4AohvdxRgxMYBYagVWQAaS9ICP2/9+zHP/faFuBMVaVWAUZYbaD7HI3usrQm7oabi3IJTCAVTdMEpkmWiGK1TDPg0wi2VqirKSzIhTfIYcPeiAjyyH7HFmcKLcja8DHHjUMX+hgl8MZm8jpFlnr18mKDL9OCyILwdmjEQAPCqIZo2FGdFDBFY6QMMOZN+EBgcbAVwKjKYVz8eVnuCI0BlXDH81sirijDiM1+EZDbDTESA0BUtWPprHRECM1BEhVDwDYaTK+XEBdcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Romania.png
// module id = 486
// module chunks = 7